import React from 'react';
import { Link } from 'react-router-dom';

export default function ForbiddenPage() {
  return (
    <div className="max-w-lg mx-auto mt-20 p-6 border rounded shadow text-center">
      <h1 className="text-3xl font-bold mb-2">403</h1>
      <p className="mb-6">You do not have permission to access this page.</p>
      <Link to="/dashboard" className="text-blue-600 hover:underline">
        Go back to dashboard
      </Link>
    </div>
  );
}

